import { KeyboardEvent, FunctionComponent, MutableRefObject } from 'react';
import { useQuery } from '../request/hooks/useQuery';
import { RetryApiAlertProps } from '../shared/components/RetryApiAlert/RetryApiAlert';
import { EmptyWidgetProps } from '../shared/components/EmptyWidget/EmptyWidget';
import { TableProps } from '../table/Table';

export type EntityListMode = 'standalone' | 'connected';
type Unboxed<T> = T extends (infer U)[] ? U : T;

export interface ListComponentBaseProps<D extends object[]> {
  data: D;
  listMode: EntityListMode;
  dataId?: string;
  getNext?: VoidFunction;
  focusIndex?: number;
  refresh?: VoidFunction;
  writeData?: ReturnType<typeof useQuery>['writeData'];
  listRef?: MutableRefObject<HTMLDivElement>;
  handleKeyPress?: (event: KeyboardEvent<HTMLDivElement>) => void;
  hideColumns?: Array<string>;
  sortThroughHeader?: { [key: string]: string };
  tableProps: Pick<
    TableProps<Unboxed<D>>,
    | 'withoutShadow'
    | 'compactHeader'
    | 'sortState'
    | 'onSort'
    | 'bulkSelection'
    | 'onItemSelectionChange'
    | 'onAllInPageSelectionChange'
    | 'selectedItems'
    | 'disableClick'
    | 'totalCount'
    | 'onAllItemsSelectionChange'
    | 'BulkActionsComponent'
    | 'bulkActionsComponentProps'
    | 'classes'
  >;
}

export type StandaloneModeActionsComponent<S> = FunctionComponent<S>;

export interface EntityListNonIdleProps {
  errorComponentProps?: Partial<RetryApiAlertProps>;
  newListComponentProps?: Partial<EmptyWidgetProps>;
}

export enum EntityListNavigationType {
  PAGE_NUMBER,
  INFINITE_SCROLL
}
